import { Component, inject, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from 'src/app/alert-notify/alert-notify.service';
import { AuthService } from 'src/services/auth.service';
import { EcitationUserService } from 'src/services/ecitation-user.service';
import { VendorService } from 'src/services/vendor.service';

@Component({
    selector: 'app-ecitation-vendor',
    templateUrl: './ecitation-vendor.component.html',
    styleUrls: ['./ecitation-vendor.component.css'],
    standalone: false
})
export class EcitationVendorComponent {


	addVendorForm: any = FormGroup
	editVendorForm: any = FormGroup
	listAllCourt:any=[]
	courtCustomer:any=[]
	listAllVendor:any=[];
	masterList:any=[]
	loggedInUserName:any
	listEditVendorDetails:any=[]
	private modalService = inject(NgbModal);
	closeResult = '';
	mode='';
	userType:any;
	alert:any = null
	constructor(private vendorService: VendorService,
		private formBuilder: FormBuilder,
		private ecitationUserService:EcitationUserService,public alertService:AlertService, public authService: AuthService) { }

	ngOnInit() {
		let loginData = sessionStorage.getItem('loggedInUser');
		this.userType = this.authService.getUserType();
		let item = loginData && JSON.parse(loginData)
		this.loggedInUserName = item?.username ?? ''

		this.editVendorForm = this.formBuilder.group({
			vendorName: [null, [Validators.required]],
			
		})
		this.getAgencyList();
		this.getAllVendorList();
	}

	pageSize:number = 10;
	currentPage:number =1;

	getItems(){
		const satrtIndex = (this.currentPage - 1) * this.pageSize;
		return this.listAllVendor.slice(satrtIndex , satrtIndex + this.pageSize);
	}

	onPageChange(pageNumber:number){
		this.currentPage = pageNumber
	}

	getTotalPages():number{
		return Math.ceil(this.listAllVendor.length / this.pageSize);
	}

	getVisiblePages():number[]{
		const totalVisiblePages = 10;
		const visiblePages:number[]=[];
		const startPage = Math.max(1, this.currentPage - Math.floor(totalVisiblePages/2));
		const endPage = Math.min(this.getTotalPages(), startPage + totalVisiblePages - 1);
		for(let i = startPage; i<=endPage; i++){
			visiblePages.push(i)
		}
		return visiblePages
	}

	

	filterItems(searchQuery:string){
		console.log(searchQuery)
		this.currentPage =1;
		this.listAllVendor = this.masterList.filter((item: any) => 
		JSON.stringify(item.vendorName).toLowerCase().includes(searchQuery.toLowerCase()))
		
	}

	getAgencyList() {
		this.ecitationUserService.getAgencyList('allUnassignedCourts').subscribe((res: any) => {
			this.listAllCourt = res
		})
	}

	getAllVendorList() {
		this.vendorService.getAllVendor().subscribe((res: any) => {
			this.listAllVendor = res;
			this.masterList =res;
		})
	}

	

	selectOption(){
		console.log(this.courtCustomer)
	}


	vendorId:any
	currentCourtNames:any=[]
	edit(contentda: TemplateRef<any>,mode:string,vendorId:number|null) {
		this.vendorId = vendorId;
		this.alert = null
		this.modalService.open(contentda, { ariaLabelledBy: 'modal-basic-title' }).result.then(
			(result) => {
				this.closeResult = `Closed with: ${result}`;
			},
			(reason) => {
				this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
			},
		);
		this.editVendorForm.reset()
		this.mode =mode;
		if(mode =='edit'){
		this.listEditVendorDetails = this.listAllVendor.filter((key: any) => key.vendorId === vendorId)
		console.log(this.listEditVendorDetails)
		let vendorName = this.listEditVendorDetails[0].vendorName
		 this.currentCourtNames = this.listEditVendorDetails[0].currentCourtNames
		this.editVendorForm = this.formBuilder.group({
			vendorName: [vendorName, [Validators.required]],
			newCourtNames: [this.currentCourtNames,[]],
		})
		
	}
	document.getElementById('vendorName')?.focus()
	}

	updateVendor() {
		if(this.editVendorForm.valid){
		let formData = this.editVendorForm.value;

		let data ;
		if(
			this.mode === 'add'
		){
			data = {
				vendorName: formData.vendorName,
				currentCourtNames: this.courtCustomer,
				loggedInUserName:this.loggedInUserName,
			}

		}else{data= {
			vendorId: this.vendorId,
			vendorName:formData.vendorName,
			currentCourtNames:formData.newCourtNames,
			loggedInUserName:this.loggedInUserName
			
		}}
		
		this.vendorService.addNewVendor(data).subscribe((res:any) => {
			if (res.errorMessage && res.errorMessage !== '') {
				this.alert = {

					message: res.errorMessage,

				}
			} else {
				
				this.alert = null
			console.log(res)
			this.courtCustomer= []
			this.listAllCourt =[]
			this.getAllVendorList();
			this.getAgencyList()	
			this.modalService.dismissAll();
			const filterInp  = document.getElementById('inputPassword6') as HTMLInputElement;
					if(filterInp){
						filterInp.value ='';
					}
			this.alertService.success(this.mode === 'add'?`New vendor - ${formData.vendorName} added sucessfully`:` ${formData.vendorName} updated sucessfully` )
			}
		})
	}else{
		for(let props in this.editVendorForm.controls){
			this.editVendorForm.get(props).markAsTouched()
		}
	}
	}
	onSort(event:any,name:any,isSortable:boolean){
		if(isSortable ){
		let spanEle = event.target.querySelector('i') != null ? event.target.querySelector('i'): event.target,
		classList =spanEle.classList;
		let sortDir = 1;
		if(classList.contains('fa-sort')||classList.contains('fa-sort-up')){
		  classList.remove('fa-sort')
		  classList.remove('fa-sort-up')
		  classList.add('fa-sort-down')
		  sortDir= -1
		}else{
		  classList.add('fa-sort-up')
		  classList.remove('fa-sort-down')
		 
		}
		this.sortBy(name,sortDir)
	  }
	  }
	  sortBy(name:string,order:number){
		this.listAllVendor.sort((a:any,b:any)=>{
		 a = isNaN(a[name])? String(a[name]).toLowerCase(): Number(a[name]);
		 b = isNaN(b[name])? String(b[name]).toLowerCase(): Number(b[name]);
		 if(order == 1){
	 return a < b ? -1 :(a > b ?1:0)
		 }else{
		  return b < a ? -1 :(b > a ?1:0)
		 }
		})
	  }

	private getDismissReason(reason: any): string {
		switch (reason) {
			case ModalDismissReasons.ESC:
				return 'by pressing ESC';
			case ModalDismissReasons.BACKDROP_CLICK:
				return 'by clicking on a backdrop';
			default:
				return `with: ${reason}`;
		}
	}
	getCurrentPageTotal(){
		if(this.currentPage * 10 > this.listAllVendor.length ){
		 return this.listAllVendor.length 
		} else{
		  return this.currentPage * 10 
		}
	  }


}
